/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartsent2Inputs */

const en_authstartsent2 = /** @type {(inputs: Authstartsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const pt_authstartsent2 = /** @type {(inputs: Authstartsent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique o seu email`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Authstartsent2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartsent2 = /** @type {((inputs?: Authstartsent2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartsent2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartsent2(inputs)
	return pt_authstartsent2(inputs)
});
export { authstartsent2 as "authStartSent" }